// Returns tailwind utility classes based on a 0-100 wine rating.
// Used by WineCard (small badge) and WineDetail (large score circle).

const RATING_TIERS = [
  { min: 95, text: "text-gold",         border: "border-gold/40",         bg: "bg-gold/10" },
  { min: 90, text: "text-gray-300",     border: "border-gray-300/40",     bg: "bg-gray-300/10" },
  { min: 86, text: "text-amber-600",    border: "border-amber-600/40",    bg: "bg-amber-600/10" },
  { min: 81, text: "text-emerald-400",  border: "border-emerald-400/40",  bg: "bg-emerald-400/10" },
  { min: 77, text: "text-sky-400",      border: "border-sky-400/40",      bg: "bg-sky-400/10" },
  { min: 70, text: "text-yellow-400",   border: "border-yellow-400/40",   bg: "bg-yellow-400/10" },
  { min: 0,  text: "text-amber-800",    border: "border-amber-800/40",    bg: "bg-amber-800/10" },
];

// Compact variant for WineCard (lighter borders/bg)
const RATING_TIERS_COMPACT = [
  { min: 95, text: "text-gold",         border: "border-gold/30",         bg: "bg-gold/5" },
  { min: 90, text: "text-gray-300",     border: "border-gray-300/30",     bg: "bg-gray-300/5" },
  { min: 86, text: "text-amber-600",    border: "border-amber-600/30",    bg: "bg-amber-600/5" },
  { min: 81, text: "text-emerald-400",  border: "border-emerald-400/30",  bg: "bg-emerald-400/5" },
  { min: 77, text: "text-sky-400",      border: "border-sky-400/30",      bg: "bg-sky-400/5" },
  { min: 70, text: "text-yellow-400",   border: "border-yellow-400/30",   bg: "bg-yellow-400/5" },
  { min: 0,  text: "text-amber-800",    border: "border-amber-800/30",    bg: "bg-amber-800/5" },
];

function pickTier(rating, tiers) {
  return tiers.find((t) => rating >= t.min) || tiers[tiers.length - 1];
}

export function getRatingClasses(rating) {
  const t = pickTier(rating, RATING_TIERS);
  return `${t.text} ${t.border} ${t.bg}`;
}

export function getRatingClassesCompact(rating) {
  const t = pickTier(rating, RATING_TIERS_COMPACT);
  return `${t.text} ${t.border} ${t.bg}`;
}
